import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { lazyImport } from '@helpers'
import {
  withApollo,
  withErrorBoundary,
  withExchangeRates,
  withI18next,
  withSkeletonTheme,
  withStaffPickImage,
  withSuspense,
  withTheme,
} from '@hocs'
import { withWishlist } from '../hocs/withWishlist'

const { SimilarProductsSlider } = lazyImport(
  () => import('@components/SimilarProductsSlider/SimilarProductsSlider'),
  'SimilarProductsSlider',
)

const relatedAndComplementaryProductsEl = document.getElementById(
  'related-and-complementary-products',
)
const productHandle = relatedAndComplementaryProductsEl?.getAttribute(
  'data-product-handle',
)

export const renderRelatedProductsApp = (relatedProductsSettingsJson: any) => {
  if (
    relatedAndComplementaryProductsEl &&
    relatedProductsSettingsJson?.enabled
  ) {
    const RelatedProductsApp = () => (
      <SimilarProductsSlider productHandle={productHandle || ''} />
    )

    const RelatedProductsAppWrapper = pipe(
      RelatedProductsApp,
      withSuspense,
      withStaffPickImage,
      withExchangeRates,
      withWishlist,
      withSkeletonTheme,
      withI18next,
      withApollo,
      withErrorBoundary,
      withTheme,
    )

    ReactDOM.createRoot(relatedAndComplementaryProductsEl).render(
      <RelatedProductsAppWrapper />,
    )
  }
}
